import { orderBy } from "element-plus/es/components/table/src/util";
import { createStore } from "vuex";

// 引入插件
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state: {
    // 个人账户信息
    userInfo: {
      access_token: "",
      expires_in: "",
      token_type: "",
    },
    quantity: 0, // 购物车加车数量
    session_id: null, // 登录/无登录标识符
    order_number: null, // 当前订单号
    store_currency: "USD", // 当前货币
    store_preferential: null, // 是否开启优惠折扣
  },
  mutations: {
    set_userinfo(state, data) {
      state.userInfo = data;
    },
    setQuantity(state, params) {
      state.quantity = params;
    },
    setSession_id(state, params) {
      state.session_id = params;
    },
    setOrder_number(state, params) {
      state.order_number = params;
    },
    set_store_currency(state, params) {
      state.store_currency = params;
    },
    set_store_preferential(state, params) {
      state.store_preferential = params;
    },
  },
  actions: {
    set_userinfo(context, data) {
      context.commit("set_userinfo", data);
    },
    setQuantity(context, params) {
      context.commit("setQuantity", params);
    },
    setSession_id(context, params) {
      context.commit("setSession_id", params);
    },
    setOrder_number(context, params) {
      context.commit("setOrder_number", params);
    },
    set_store_currency(context, params) {
      context.commit("set_store_currency", params);
    },
    set_store_preferential(context, params) {
      context.commit("set_store_preferential", params);
    },
  },
  // vuex数据持久化配置
  plugins: [
    createPersistedState({
      // 存储方式：localStorage sessionStorage cookies
      storage: window.sessionStorage,
      // 存储的 key 的key值
      key: "store",
    }),
  ],
});
